/* AFIQ universal PDP (sections/afiq-pdp-*.liquid).
   Prices every set with the same maths Shopify's Deck Ladder automatic discounts use:
   cart-wide deck count -> tier %, discount floored PER UNIT. A bundle SKU is only added when it is
   cheaper than the ladder for exactly the same decks. Everything else is plain line items. */
(function () {
  'use strict';
  var root = document.querySelector('.apdp-main');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-apdp-data]').textContent);
  var C = D.current;
  var byHandle = {};
  D.catalog.forEach(function (p) { byHandle[p.handle] = p; });
  if (!byHandle[C.handle]) byHandle[C.handle] = { handle: C.handle, variant: C.variant, price: C.price, available: C.available, label: C.label, short: C.short, kind: C.kind, order: 0, img: '' , ladder: C.ladder };
  D.catalog.forEach(function (p) { p.ladder = true; });

  /* ---------- helpers ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2), f = D.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function tier(n) { var t = { min: 1, pct: 0 }; D.ladder.forEach(function (x) { if (n >= x.min && x.pct >= t.pct) t = x; }); return t; }
  function nextTier(n) { var best = null; D.ladder.forEach(function (x) { if (x.min > n && x.pct > 0 && (!best || x.min < best.min)) best = x; }); return best; }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) { var d = { event: name }; for (var k in params) d[k] = params[k]; window.dataLayer.push(d); } } catch (e) {}
  }

  /* Price a list of deck handles (repeats allowed): the cheapest real checkout route. Either the ladder
     on every deck, or one bundle SKU plus the ladder on whatever else is in the cart. Exception: all four
     volumes always use the Elite bundle line (it's the product the shopper chose). */
  function ladderCost(handles) {
    var n = 0, t = 0; handles.forEach(function (h) { if (byHandle[h].ladder) n++; });
    var pct = tier(n).pct;
    handles.forEach(function (h) { var p = byHandle[h]; t += p.ladder ? p.price - Math.floor(p.price * pct / 100) : p.price; });
    return t;
  }
  function priceDecks(handles) {
    var ladderN = 0, full = 0;
    handles.forEach(function (h) { var p = byHandle[h]; full += p.price; if (p.ladder) ladderN++; });
    var total = ladderCost(handles), bundle = null, rest = handles, forced = null;
    D.bundles.forEach(function (b) {
      if (!b.available) return;
      var r = handles.slice(), ok = b.decks.every(function (d) { var i = r.indexOf(d); if (i < 0) return false; r.splice(i, 1); return true; });
      if (!ok) return;
      var t = b.price + ladderCost(r);
      if (t < total) { total = t; bundle = b; rest = r; }
      /* All four volumes chosen: always the Elite bundle line, even if loose decks on the ladder are a few dollars cheaper. */
      if (b.decks.length === 4) forced = { total: t, bundle: b, rest: r };
    });
    if (forced && bundle !== forced.bundle) { total = forced.total; bundle = forced.bundle; rest = forced.rest; }
    return { n: handles.length, ladderN: ladderN, pct: tier(ladderN).pct, full: full, total: total, save: full - total, bundle: bundle, rest: rest, perDeck: Math.round(total / handles.length) };
  }

  function tierPos(n) { return n <= 1 ? 0 : n <= 4 ? (n - 1) / 3 * 62 : Math.min(100, 62 + (n - 4) / 6 * 38); }
  function tierBar(n, dark) {
    var nx = nextTier(n), cur = tier(n);
    var msg = nx ? 'Add ' + (nx.min - n) + ' more deck' + (nx.min - n > 1 ? 's' : '') + ' → <b>' + nx.pct + '% off every deck</b>' : '<b>Team pricing unlocked</b>';
    var ticks = D.ladder.filter(function (t) { return t.pct > 0; });
    return '<div class="apdp-tier' + (dark ? ' is-dark' : '') + '"><div class="apdp-tier-t"><span>' + n + ' deck' + (n === 1 ? '' : 's') + ' · <b>' + (cur.pct ? cur.pct + '% off every deck' : 'full price') + '</b></span><span>' + msg + '</span></div>' +
      '<div class="apdp-tier-bar"><i style="width:' + tierPos(n) + '%"></i>' + ticks.map(function (t) { return '<em class="' + (n >= t.min ? 'is-on' : '') + '" style="left:' + tierPos(t.min) + '%"></em>'; }).join('') + '</div>' +
      '<div class="apdp-tier-l"><span style="left:0">1</span>' + ticks.map(function (t, i) { return '<span class="' + (n >= t.min ? 'is-on' : '') + (i === ticks.length - 1 ? ' is-last' : '') + '" style="left:' + tierPos(t.min) + '%">' + t.min + (t.min >= 4 ? '+' : '') + ' · ' + t.pct + '%</span>'; }).join('') + '</div></div>';
  }

  /* ---------- set options ---------- */
  function vols() {
    return D.catalog.filter(function (p) { return p.kind === 'volume' && p.available; }).sort(function (a, b) { return a.order - b.order; }).map(function (p) { return p.handle; });
  }
  function buildOptions() {
    if (!C.ladder) return [{ key: 'one', decks: [C.handle], title: C.label + ' only', note: '1 deck' }];
    if (C.kind === 'basics') {
      var ob = [];
      if (C.pair && byHandle[C.pair]) ob.push({ key: 'pair', decks: [C.handle, C.pair], title: '+ ' + byHandle[C.pair].label, note: '2 decks · the next step up' });
      ob.push({ key: 'one', decks: [C.handle], title: C.label + ' only', note: '1 deck' });
      return ob;
    }
    if (C.kind === 'flag') {
      var o = [];
      if (C.teamOffer) {
        o.push({ key: 'four', decks: [C.handle, C.handle, C.handle, C.handle], title: "Coach's 4-pack", note: '4 decks · for a coach and a small group', tag: ['Save ' + tier(4).pct + '%', 'alt'] });
        o.push({ key: 'ten', decks: Array(10).fill(C.handle), title: 'Team 10-pack', note: '10 decks · a deck for every player', tag: ['Team price', 'red'] });
      }
      if (C.pair && byHandle[C.pair]) o.push({ key: 'pair', decks: [C.handle, C.pair], title: '+ ' + byHandle[C.pair].label, note: '2 decks' });
      o.push({ key: 'one', decks: [C.handle], title: C.short + ' only', note: '1 deck' });
      return o;
    }
    var opts = [], set = vols();
    if (set.indexOf(C.handle) < 0) set.push(C.handle);
    if (set.length >= 3) {
      var first = byHandle[set[0]].short, last = byHandle[set[set.length - 1]].short.replace(/^Vol\s*/i, '');
      opts.push({ key: 'set', decks: set, title: D.labels.fullSet + ', ' + first + '–' + last, note: set.length + ' decks', tag: [D.labels.mostPopular, 'red'], complete: true });
    }
    /* Merchandising: the full system leads; one middle-priced set sits between it and the single deck so the
       price per deck reads as a ladder (Michael, 2026-09-30). Trio when the product has one, otherwise its pair. */
    var trio = (C.trio || []).filter(function (h) { return byHandle[h]; });
    if (trio.length === 3 && trio.join() !== set.join()) {
      var core = trio.every(function (h, i) { return byHandle[h].order === i + 1; });
      opts.push({ key: 'trio', decks: trio, title: core ? 'Volumes 1–3' : trio.map(function (h) { return byHandle[h].short; }).join(' + '), note: '3 decks · ' + (core ? 'the core system' : 'foundation + your position') });
    } else if (C.pair && byHandle[C.pair]) {
      var pr = [C.handle, C.pair].sort(function (a, b) { return byHandle[a].order - byHandle[b].order; });
      opts.push({ key: 'pair', decks: pr, title: '+ ' + byHandle[C.pair].label, note: '2 decks · ' + byHandle[C.pair].name.toLowerCase() });
    }
    opts.push({ key: 'one', decks: [C.handle], title: C.label + ' only', note: '1 deck' });
    /* A/B variant B (2026-10-12): the single deck leads and is pre-selected; the full system sits last. */
    return opts.reverse();
  }

  var state = { opt: null, owned: {}, byo: {}, add: {} };
  var OPTS = buildOptions();
  state.opt = OPTS[0].key;
  function optDecks(o) { return o.complete ? o.decks.filter(function (h) { return h === C.handle || !state.owned[h]; }) : o.decks; }

  /* ---------- add-ons: Flag 5v5 and Basics upsell on volume pages; the full system on Flag/Basics pages ---------- */
  function byKind(k) { return D.catalog.filter(function (p) { return p.kind === k && p.available; })[0]; }
  function buildAddons() {
    var a = [], flag = byKind('flag'), basics = byKind('basics'), set = vols();
    if (C.kind !== 'volume' && set.length >= 3) a.push({ key: 'set', decks: set, title: 'Add ' + D.labels.fullSet.toLowerCase(), note: set.length + ' volumes · ' + set.length * 54 + ' cards', img: byHandle[set[set.length - 1]].img, stack: true });
    if (flag && C.kind !== 'flag') a.push({ key: 'flag', decks: [flag.handle], title: 'Add ' + flag.label, note: 'For the 5v5 game', img: flag.img });
    if (basics && C.kind !== 'basics') a.push({ key: 'basics', decks: [basics.handle], title: 'Add ' + basics.label, note: 'For a brand-new player or parent', img: basics.img });
    return C.ladder ? a : [];
  }
  var ADDONS = buildAddons();
  function addonDecks(except) { var d = []; ADDONS.forEach(function (a) { if (state.add[a.key] && a.key !== except) d = d.concat(a.decks); }); return d; }

  function stackHtml(decks) {
    var uniq = decks.filter(function (h, i) { return decks.indexOf(h) === i; }).slice(0, 5);
    return uniq.map(function (h, i) { var p = byHandle[h]; return p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" style="left:' + i * (uniq.length > 3 ? 11 : 15) + 'px;z-index:' + i + '">' : ''; }).join('') +
      (decks.length > uniq.length ? '<span class="apdp-x">×' + decks.length + '</span>' : '');
  }
  function optHtml(o) {
    var decks = optDecks(o), q = priceDecks(decks), sel = state.opt === o.key;
    var chips = '';
    if (o.complete && sel) {
      chips = '<div class="apdp-own">' + o.decks.map(function (h) {
        var p = byHandle[h];
        if (h === C.handle) return '<span class="apdp-chip is-lock">' + chk + esc(p.short) + '<small>this deck</small></span>';
        var off = !!state.owned[h];
        return '<button type="button" class="apdp-chip' + (off ? ' is-off' : '') + '" data-own="' + esc(h) + '" aria-pressed="' + !off + '">' + (off ? '' : chk) + esc(p.short) + '<small>' + (off ? 'have it' : 'adding') + '</small></button>';
      }).join('') + '<span class="apdp-own-h">' + esc(D.labels.ownHint) + '</span></div>';
    }
    return '<div class="apdp-opt' + (sel ? ' is-sel' : '') + '" data-opt="' + o.key + '" role="radio" aria-checked="' + sel + '" tabindex="0">' +
      (o.tag ? '<span class="apdp-otag is-' + o.tag[1] + '">' + esc(o.tag[0]) + '</span>' : '') +
      '<span class="apdp-radio"></span><span class="apdp-stack">' + stackHtml(decks) + '</span>' +
      '<div class="apdp-otx"><b>' + esc(o.title) + '</b><p>' + esc(o.note) + (decks.length > 1 ? ' · ' + money(q.perDeck) + '/deck' : '') + '</p>' + (q.bundle ? '<span class="apdp-via">' + esc(q.bundle.title) + ' price</span>' : '') + '</div>' +
      '<div class="apdp-price"><b>' + money(q.total) + '</b>' + (q.save > 0 ? '<s>' + money(q.full) + '</s><span class="apdp-save">SAVE ' + money(q.save) + '</span>' : '') + '</div>' + chips + '</div>';
  }
  var chk = '<svg class="apdp-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>';

  var elOpts = root.querySelector('[data-apdp-opts]'), elTier = root.querySelector('[data-apdp-tier]'),
      elAtcLabel = root.querySelector('[data-apdp-atc-label]'), elAtc = root.querySelector('[data-apdp-atc]'),
      elXpay = root.querySelector('[data-apdp-xpay]'), elStatus = root.querySelector('[data-apdp-status]'),
      elSticky = root.querySelector('[data-apdp-sticky]');

  function current() { var o = OPTS.filter(function (x) { return x.key === state.opt; })[0]; var d = optDecks(o).concat(addonDecks()); return { o: o, decks: d, q: priceDecks(d) }; }
  function addonHtml(a) {
    var base = optDecks(OPTS.filter(function (x) { return x.key === state.opt; })[0]).concat(addonDecks(a.key));
    var extra = priceDecks(base.concat(a.decks)).total - priceDecks(base).total, list = a.decks.reduce(function (s, h) { return s + byHandle[h].price; }, 0), on = !!state.add[a.key];
    return '<button type="button" class="apdp-addon' + (on ? ' is-on' : '') + '" data-addon="' + a.key + '" aria-pressed="' + on + '"><span class="apdp-addon-box">' + (on ? chk : '+') + '</span>' +
      (a.stack ? '<span class="apdp-stack">' + stackHtml(a.decks) + '</span>' : (a.img ? '<img src="' + esc(a.img) + '" alt="" loading="lazy">' : '<span></span>')) +
      '<span class="apdp-addon-t"><b>' + esc(a.title) + '</b><small>' + esc(a.note) + '</small></span><span class="apdp-addon-p"><b>+' + money(extra) + '</b>' + (extra < list ? '<s>' + money(list) + '</s>' : '') + '</span></button>';
  }
  function renderBuy() {
    elOpts.innerHTML = OPTS.map(optHtml).join('');
    var elAdd = root.querySelector('[data-apdp-addons]');
    if (elAdd) { elAdd.innerHTML = ADDONS.length ? '<div class="apdp-opt-h"><span class="apdp-eyebrow">Complete the kit</span><small>Optional add-ons</small></div>' + ADDONS.map(addonHtml).join('') : ''; }
    var c = current();
    elTier.innerHTML = C.ladder ? tierBar(c.q.ladderN) : '';
    if (elAtcLabel && C.available) elAtcLabel.textContent = (c.decks.length > 1 ? 'Add ' + c.decks.length + ' decks' : 'Add to cart') + ' · ' + money(c.q.total);
    if (elXpay) elXpay.hidden = c.decks.length !== 1;
    if (elSticky) {
      var nAdd = ADDONS.filter(function (a) { return state.add[a.key]; }).length;
      elSticky.querySelector('[data-apdp-sticky-title]').textContent = c.o.title + (nAdd ? ' + ' + nAdd : '');
      elSticky.querySelector('[data-apdp-sticky-price]').innerHTML = money(c.q.total) + (c.q.save > 0 ? ' <s>' + money(c.q.full) + '</s>' : '');
    }
  }

  /* ---------- cart ---------- */
  function cartSections() {
    var drawer = document.querySelector('cart-drawer'), notif = document.querySelector('cart-notification');
    if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender();
    if (notif && typeof notif.getSectionsToRender === 'function') return notif.getSectionsToRender();
    return [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];
  }
  function itemsFor(decks, q, source) {
    var items = q.bundle ? [{ id: q.bundle.variant, quantity: 1 }] : [];
    var counts = {};
    (q.bundle ? q.rest : decks).forEach(function (h) { counts[h] = (counts[h] || 0) + 1; });
    return items.concat(Object.keys(counts).map(function (h) { return { id: byHandle[h].variant, quantity: counts[h] }; }));
  }
  function addToCart(decks, q, source, btn) {
    if (!decks.length) return;
    if (btn) btn.disabled = true;
    var payload = { items: itemsFor(decks, q, source) };
    var ids = cartSections().map(function (x) { return x.id; }).filter(function (v, i, a) { return v && a.indexOf(v) === i; });
    if (ids.length) { payload.sections = ids; payload.sections_url = (window.routes && window.routes.cart_url) || '/cart'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || D.labels.error); return d; }); })
      .then(function (data) {
        /* upsell attribution: ticked add-ons on the set picker / sticky bar (not the build-your-own grid) */
        if ((source === 'pdp-set' || source === 'pdp-sticky') && window.AFIQ_UI && AFIQ_UI.tagUpsell) {
          var UPS = { set: 'full-system', flag: 'flag', basics: 'basics' };
          AFIQ_UI.tagUpsell(ADDONS.filter(function (a) { return state.add[a.key]; }).map(function (a) { return 'b10x-upsell-pdp-' + (UPS[a.key] || a.key); }));
        }
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { order_source: source } }) }).catch(function () {});
        track('pdp_set_add_to_cart', { currency: D.currency, value: +(q.total / 100).toFixed(2), decks: decks.length, tier_percent: q.pct, bundle: q.bundle ? q.bundle.title : '', product: C.handle, source: source });
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
        else if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(); }
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (elStatus) elStatus.textContent = D.labels.added;
      })
      .catch(function (e) { if (elStatus) elStatus.textContent = e.message || D.labels.error; })
      .then(function () { if (btn) btn.disabled = false; });
  }

  var form = root.querySelector('form.apdp-form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var c = current(); addToCart(c.decks, c.q, 'pdp-set', elAtc);
  });
  root.addEventListener('click', function (e) {
    var own = e.target.closest('[data-own]');
    if (own) { e.stopPropagation(); var h = own.getAttribute('data-own'); state.owned[h] = !state.owned[h]; renderBuy(); return; }
    var ad = e.target.closest('[data-addon]');
    if (ad) { var k = ad.getAttribute('data-addon'); state.add[k] = !state.add[k]; renderBuy(); track('pdp_addon_toggle', { addon: k, on: state.add[k], product: C.handle }); return; }
    var opt = e.target.closest('[data-opt]');
    if (opt) { state.opt = opt.getAttribute('data-opt'); renderBuy(); track('pdp_set_select', { option: state.opt, product: C.handle }); return; }
    var th = e.target.closest('[data-apdp-thumb]');
    if (th) { goTo(+th.getAttribute('data-apdp-thumb')); return; }
    if (e.target.closest('[data-apdp-prev]')) { goTo(slideIdx() - 1); return; }
    if (e.target.closest('[data-apdp-next]')) { goTo(slideIdx() + 1); return; }
    if (e.target.closest('[data-apdp-sticky-add]')) { var c = current(); addToCart(c.decks, c.q, 'pdp-sticky', e.target.closest('button')); }
  });
  elOpts.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-opt]')) { e.preventDefault(); e.target.click(); } });

  /* ---------- gallery slider (scroll-snap: native swipe on touch, thumbs/arrows on desktop) ---------- */
  var gTrack = root.querySelector('[data-apdp-track]');   // not `track`: that name is the analytics helper above
  function slideIdx() { return gTrack ? Math.round(gTrack.scrollLeft / Math.max(1, gTrack.clientWidth)) : 0; }
  function goTo(i) {
    if (!gTrack) return; var n = gTrack.children.length; i = (i + n) % n;
    // Hand-rolled ease: native smooth scrollTo is cancelled by scroll-snap in Chromium.
    var from = gTrack.scrollLeft, to = i * gTrack.clientWidth, t0 = performance.now(), dur = 320;
    if (from === to) return;
    gTrack.style.scrollSnapType = 'none'; gTrack.style.scrollBehavior = 'auto';
    (function step(now) {
      var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      gTrack.scrollLeft = from + (to - from) * e;
      if (k < 1) requestAnimationFrame(step); else { gTrack.style.scrollSnapType = ''; gTrack.style.scrollBehavior = ''; }
    })(t0);
  }
  if (gTrack) {
    var dots = root.querySelectorAll('.apdp-dots span'), idxEl = root.querySelector('[data-apdp-idx]'), raf = 0;
    gTrack.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = slideIdx();
        if (idxEl) idxEl.textContent = i + 1;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        root.querySelectorAll('[data-apdp-thumb]').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-apdp-thumb') === i); });
      });
    }, { passive: true });
    gTrack.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') goTo(slideIdx() + 1); if (e.key === 'ArrowLeft') goTo(slideIdx() - 1); });
  }

  /* ---------- sticky bar ---------- */
  function stickyUpd() { if (!elSticky) return; var show = elAtc.getBoundingClientRect().bottom < 0; elSticky.classList.toggle('is-show', show); elSticky.setAttribute('aria-hidden', String(!show)); }
  window.addEventListener('scroll', stickyUpd, { passive: true });
  function stickyOffset() { // float above the Klaviyo teaser (same approach as the bundle builder)
    if (!elSticky) return; var vh = window.innerHeight, off = 0;
    document.querySelectorAll('body div, body section, body aside').forEach(function (n) {
      if (n === elSticky || root.contains(n)) return; var cs = getComputedStyle(n);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = n.getBoundingClientRect(); if (!r.height || r.height > 220 || Math.abs(r.bottom - vh) > 2 || r.width < innerWidth * 0.5) return;
      off = Math.max(off, Math.round(r.height));
    });
    elSticky.style.bottom = off + 'px';
  }
  [400, 1500, 4000].forEach(function (ms) { setTimeout(stickyOffset, ms); });

  /* ---------- build your own ---------- */
  var byoEl = document.querySelector('[data-apdp-byo]');
  if (byoEl && C.ladder) {
    var decksList = D.catalog.filter(function (p) { return p.available; }).sort(function (a, b) { return a.order - b.order; });
    if (C.kind === 'flag') state.byo[C.handle] = 6;
    else { var vs = vols(); (vs.indexOf(C.handle) >= 0 ? vs : [C.handle]).forEach(function (h) { if (byHandle[h]) state.byo[h] = 1; }); }
    var books = document.querySelector('[data-apdp-books]');
    if (books) books.innerHTML = decksList.filter(function (p) { return p.kind !== 'basics'; }).slice(0, 5).map(function (p, i) { return p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.label) + '" loading="lazy" style="--i:' + i + '">' : ''; }).join('');
    var renderByo = function () {
      var hs = []; decksList.forEach(function (p) { for (var i = 0; i < (state.byo[p.handle] || 0); i++) hs.push(p.handle); });
      var q = hs.length ? priceDecks(hs) : { n: 0, full: 0, total: 0, save: 0, pct: 0, perDeck: 0, ladderN: 0 };
      if (q.bundle) q = (function () { var t = 0, pct = tier(hs.length).pct; hs.forEach(function (h) { var p = byHandle[h]; t += p.price - Math.floor(p.price * pct / 100); }); return { n: hs.length, ladderN: hs.length, full: q.full, total: t, save: q.full - t, pct: pct, perDeck: Math.round(t / hs.length) }; })(); // builder = plain decks
      var n = q.n, nx = nextTier(n);
      byoEl.innerHTML = '<div class="apdp-byo-list">' + decksList.map(function (p) {
        var c = state.byo[p.handle] || 0;
        return '<div class="apdp-byo-row' + (c ? ' has' : '') + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '<span></span>') + '<div><b>' + esc(p.label) + '</b><span>' + esc(p.name) + (p.tag ? ' · ' + esc(p.tag) : '') + '</span></div>' +
          '<div class="apdp-step"><button type="button" data-step="' + esc(p.handle) + '" data-d="-1" aria-label="Remove one ' + esc(p.label) + '">−</button><output>' + c + '</output><button type="button" data-step="' + esc(p.handle) + '" data-d="1" aria-label="Add one ' + esc(p.label) + '">+</button></div></div>';
      }).join('') + '</div>' +
      '<div class="apdp-byo-sum">' + tierBar(n, true) +
        '<div class="apdp-sum-rows"><div><span>Decks</span><b>' + n + '</b></div><div><span>Full price</span><b>' + money(q.full) + '</b></div><div class="is-grn"><span>Multi-deck discount' + (q.pct ? ' (' + q.pct + '%)' : '') + '</span><b>−' + money(q.save) + '</b></div><div class="is-tot"><span>Total</span><b>' + money(q.total) + '</b></div><div><span>Per deck</span><b>' + (n ? money(q.perDeck) : '—') + '</b></div></div>' +
        '<button type="button" class="apdp-btn apdp-btn--red apdp-atc" data-byo-add ' + (n ? '' : 'disabled') + '>Add ' + n + ' deck' + (n === 1 ? '' : 's') + ' · ' + money(q.total) + '</button>' +
        '<p class="apdp-sum-n">' + (n >= 10 ? 'Team pricing applied. Need an invoice? <a href="' + esc(byoEl.getAttribute('data-team-url')) + '">Coaches &amp; teams →</a>' : nx && n ? (nx.min - n) + ' more deck' + (nx.min - n > 1 ? 's' : '') + ' gets every deck ' + nx.pct + '% off.' : '') + '</p>' +
        '<a class="apdp-full-builder" href="' + esc(byoEl.getAttribute('data-builder-url')) + '">Open the full bundle builder →</a></div>';
      byoEl._q = q; byoEl._hs = hs;
    };
    byoEl.addEventListener('click', function (e) {
      var s = e.target.closest('[data-step]');
      if (s) { var h = s.getAttribute('data-step'); state.byo[h] = Math.max(0, Math.min(99, (state.byo[h] || 0) + +s.getAttribute('data-d'))); renderByo(); return; }
      var a = e.target.closest('[data-byo-add]');
      if (a) { var q = byoEl._q; q.bundle = null; addToCart(byoEl._hs, q, 'pdp-byo', a); }
    });
    renderByo();
  } else if (byoEl) {
    var sec = byoEl.closest('.apdp-byo'); if (sec) sec.hidden = true;
  }

  renderBuy();
  stickyUpd();
})();

